var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.00002H13.3333V12H12V4.00002ZM2.66663 8.66669H8.39063L5.52863 11.5287L6.47129 12.4714L10.9426 8.00002L6.47129 3.52869L5.52863 4.47135L8.39063 7.33335H2.66663V8.66669Z",
    fill: "#9499A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightTo);
export default __webpack_public_path__ + "static/media/arrow-right-to.d055af2c4076f070eee46571a42f31f7.svg";
export { ForwardRef as ReactComponent };